import React from 'react';
interface BodyParagraphProps {
  children: React.ReactNode;
}
export function BodyParagraph({
  children
}: BodyParagraphProps) {
  return <p className="text-[1.05rem] md:text-[clamp(1.05rem,1.5vw,1.333rem)] text-[#7A8290] animate-fadeIn leading-relaxed" data-id="element-121">
      {children}
    </p>;
}